import React from "react";
import MovieCard from "./MovieCard";
import usePreventHorizontalScroll from "../hooks/usePreventHorizontalScroll";

const MovieList = ({ title, movies }) => {
  const scrollContainerRef = usePreventHorizontalScroll();
  // console.log(movies);
  if (!movies) return null; // doing early return

  return (
    <div className="px-6 pt-2 pb-1">
      <h1 className="text-xl font-bold py-2">{title}</h1>
      <div
        ref={scrollContainerRef}
        className="flex overflow-x-auto no-scrollbar"
      >
        <div className="flex">
          {movies.map((movie) => (
            <MovieCard
              key={movie.id}
              posterPath={movie.poster_path}
              title={movie.original_title}
              date={movie.release_date}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default MovieList;
